import type { oz } from '@weft/utils';
import { MeasurementSchema } from '../../entities';

export const UpdateMeasurementsPayloadSchema = MeasurementSchema.pick({
  id: true,
  value: true,
  latestEventUpdatedAt: true,
});

export type UpdateMeasurementsPayload = oz.infer<typeof UpdateMeasurementsPayloadSchema>;